import { render, staticRenderFns } from "./app-copyright.vue?vue&type=template&id=24230156&"
import script from "./app-copyright.vue?vue&type=script&lang=ts&"
export * from "./app-copyright.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports